import { useEffect } from 'react';
import { t } from 'services/i18n.service';
import { SUPPORT_EMAIL } from 'constants/general';
import { capturePostHogEvent } from 'services/posthog.service';
import { POST_HOG_EVENT } from 'constants/events';

const privacyFeatures = [
  {
    title: 'privacy_security.privacy_protection',
    description: t(
      'privacy_security.we_do_not_log_which_websites_or_apps_you_use'
    )
  },
  {
    title: 'privacy_security.cross_platform_sync',
    description: 'privacy_security.we_sync_your_habit_data_to_our_server'
  },
  {
    title: 'privacy_security.enterprise_security',
    description:
      'privacy_security.your_data_is_encrypted_and_we_don_t_let_anyone_else_see_it'
  }
];

const PrivacySecurity = ({
  isShowPrivacyPolicyModal
}: {
  isShowPrivacyPolicyModal: boolean;
}) => {
  useEffect(() => {
    if (isShowPrivacyPolicyModal) {
      capturePostHogEvent(POST_HOG_EVENT.WEB_PROFILE.PRIVACY_SECTION_VIEWED);
    }
  }, [isShowPrivacyPolicyModal]);

  return (
    <div className='w-full ~p-4/6'>
      <div className='flex flex-col ~gap-4/6'>
        <div className='flex flex-col ~gap-4/6'>
          {privacyFeatures.map((feature) => (
            <div key={feature.title} className='flex flex-col ~gap-1/2'>
              <h6 className='~text-base/lg font-semibold'>
                {t(feature.title)}
              </h6>
              <p className='~text-sm/base text-gray-700'>
                {t(feature.description)}
              </p>
            </div>
          ))}
        </div>
        <div className='mt-4 pt-4 border-t border-gray-300'>
          <p className='~text-xs/sm text-gray-600'>
            {t('privacy_security.for_more_details_feel_free_to_email')}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className='text-primary-900 underline hover:text-primary-400'>
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacySecurity;
